import * as Yup from 'yup';
import { AccountSpecialCondition } from '../../../../../../shared/types/modules/account';

export const initialValues: AccountSpecialCondition = {
    hasSpecialCondition: false,
    specialCondition: '',
    observations: '',
};

export const validationSchema = Yup.object({
    specialCondition: Yup.string().when('hasSpecialCondition', {
        is: true,
        then: () =>
            Yup.string().required('La condición especial es obligatoria'),
    }),
    observations: Yup.string().when('hasSpecialCondition', {
        is: true,
        then: () =>
            Yup.string()
                .required('El campo observaciones es obligatorio')
                .max(
                    500,
                    'El campo observaciones debe tener 500 caracteres como máximo'
                ),
    }),
});
